import { __ } from 'i18n/index';
import { MODE_NAMES } from 'react/chat/inner/display_pieces/messages/kinds/modeNames';

/** One line describing a chat message, for menus that don't draw the whole message. */
export function messageSummary(chatMessage) {
	const lfg = chatMessage.getLfg();
	if(lfg) {
		const modeName = MODE_NAMES[lfg.mode] || MODE_NAMES.friendlies;
		return __('%1$s search · %2$s · %3$s', modeName, lfg.ladder ? lfg.ladder.name : '', lfg.main ? lfg.main.name : __('Any main'));
	}
	const result = chatMessage.getMatchResult();
	if(result) {
		return __('%1$s beat %2$s', result.winner.username, result.loser.username);
	}
	return chatMessage.message;
}
